module.exports = __webpack_public_path__ + "static/Logo@2x-8935d56ee9b010d2646fe90087895b02.png";